
export default {
  computed: {
    form() {
      var form = {};

      if (this.maxunits.length > 0 && this.allowMultiple) {
        form.units = {
          label: this.$t('Configurator.stlCount'),
          tooltip: this.$t('Configurator.stlCountTooltip'),
          type: 'select',
          required: true,
          options: {}
        };

        let minunits = Array.isArray(this.minunits) && this.minunits.length > 0 ? this.minunits[this.maxunits.length - 1] : 1;

        for (var i = minunits ; i <= this.maxunits[this.maxunits.length - 1] ; i++) {
          form.units.options['count_' + i] = {
            label: i == 1 ? this.$t('Configurator.oneUnit') : this.$t('Configurator.nUnits', {n: i}),
            amount: i
          };
        }

        form.units.defaultValue = Object.keys(form.units.options)[0]
      }

      this.properties.reverse();
      this.properties.forEach(function(properties) {
        if (properties == null) {
          return;
        }

        for (var key of Object.keys(properties)) {
          if (typeof form[key] == 'undefined') {
            // if (properties[key] == null || typeof properties[key].type == 'undefined' || properties[key].type != 'hidden') {
              form[key] = properties[key];
            // }
          }
        }
      });
      this.properties.reverse();

      // var temp = {};
      Object.keys(form).forEach(function(key) {
        if (form[key] == null) {
          delete form[key];
        }
      });

      return form;
    }
  },
  methods: {
    revertSelection() {
      this.selectionConfirmed = false;
    },
    // selectProduct is being called once a finder item is being clicked
    // addSelection is a callback from finder.vue to open the next finder frame
    // and push it to this.selection
    selectProduct(child, index, key, addSelection) {
      this.productSelected = typeof child.children == 'undefined';

      addSelection(this, index, key);
      this.updateSelection();
    },
    updateSelection(selection) {
      if (typeof selection != 'undefined') {
        this.selection = selection;
      }
      this.requireAttachments = this.collectProperties(this.selection, 'requireAttachments').pop(); // Only use the last requirement!!
      if (!(typeof this.requireAttachments === 'object' && this.requireAttachments instanceof Array)) {
        this.requireAttachments = [];
      }

      this.color = this.collectProperties(this.selection, 'color');
      this.material = this.collectProperties(this.selection, 'material');
      this.itemnums = this.collectProperties(this.selection, 'itemnum');
      this.properties = this.collectProperties(this.selection, 'properties');
      this.maxunits = [
        ...this.collectProperties(this.selection, 'maxunits'),
        ...this.collectProperties(this.selection, 'unitsMax')
      ];
      this.minunits = [
        ...this.collectProperties(this.selection, 'minunits'),
        ...this.collectProperties(this.selection, 'unitsMin')
      ];
    },
    collectProperties(selection, property) {
      var properties = [],
          branch = this.getBranch();

      this.$root.sentry(function(Raven) {
        Raven.captureBreadcrumb({
          message: 'Collecting properties',
          data: {
             branch: branch
          }
        });
      }.bind(this));

      for (var i = 0 ; i <= selection?.length ; i++) {
        if (!branch) {
          break;
        }

        // noinspection EqualityComparisonWithCoercionJS
        if (branch[property] != undefined) {
          properties.push(branch[property]);
        }

        // noinspection EqualityComparisonWithCoercionJS
        if (i >= selection.length) {
          break;
        }

        if (typeof branch.children === 'object' && branch.children !== null) {
          branch = branch.children[selection[i]];
        }
      }

      return properties;
    },
    getFilteredTree(productTree, filter) {
      // Filter properties
      if (typeof productTree.properties == 'object') {
        for (let prop of Object.keys(productTree.properties)) {
          if (productTree.properties[prop] != null) {
            const {itemnum} = productTree.properties[prop];
            if (typeof itemnum === 'string' && filter.indexOf(itemnum) > -1) {
              console.log('getFilteredTree: Remove property', prop, itemnum);
              delete productTree.properties[prop];
            }
          }
        }
      }

      // Filter children
      if (typeof productTree.children == 'object') {
        for (let key of Object.keys(productTree.children)) {
          const {itemnum} = productTree.children[key];
          if (typeof itemnum === 'string' && filter.indexOf(itemnum) > -1) {
            console.log('getFilteredTree: Remove child', key, itemnum);
            delete productTree.children[key];
          } else {
            this.getFilteredTree(productTree.children[key], filter);
            const {children} = productTree.children[key];
            if ((typeof children === 'object' && Object.keys(children).length == 0)) {
              delete productTree.children[key];
            }
          }
        }
      }
    },
    getItems(fileCount = 1) {
      let items  = {},
          deselect = [],
          amount = 1;

      //for (var key of this.formValues) {
      if (Object.keys(this.formValues).indexOf('units') >= 0
        && this.formValues.units != null
        && this.formValues.units != ''
        && typeof this.form.units != 'undefined'
        && typeof this.form.units.options != 'undefined'
        && typeof this.form.units.options[this.formValues.units] != 'undefined'
        && typeof this.form.units.options[this.formValues.units].amount != 'undefined') {
          amount = this.form.units.options[this.formValues.units].amount;
          // break;
      }
      // }

      for (var key of Object.keys(this.formValues)) {
        const value = this.formValues[key]
        const field = this.form[key]

        let itemnum, itemAmount;

        const meets = (typeof this.meetsRequirements === 'function' ? this.meetsRequirements(field) : true);
        console.log('getItems', value, field, meets);
        if ( value != null && meets) {
          if (value == null || value === '') {
            continue
          }

          itemnum = null;
          itemAmount = null;

          switch (field['type']) {
            case 'units':
              if (typeof field.itemnum != 'undefined') {
                itemnum = field.itemnum;
                itemAmount = value;
              }
              break;
            case 'select':
              if (typeof field.itemnum != 'undefined') {
                itemnum = field.itemnum;
              }
              if (Array.isArray(field.options)) {
                for (let option of field.options) {
                  const {itemnum: _itemnum, amount: _amount, value: _value} = option;
                  if (value === _value) {
                    if (typeof _itemnum != 'undefined') {
                      itemnum = _itemnum;

                      if (typeof _amount != 'undefined') {
                        itemAmount = _amount;
                      }
                    }
                    break;
                  }
                }
              } else if (typeof field.options != 'undefined') {
                const option = field.options[value];
                if (typeof option != 'undefined') {
                  const {itemnum: _itemnum, amount: _amount} = option;
                  if (typeof _itemnum != 'undefined') {
                    itemnum = _itemnum;

                    if (typeof _amount != 'undefined') {
                      itemAmount = _amount;
                    }
                  }
                }
              }
              break;
            case 'switch':
            case 'checkbox':
            default:
              if (typeof field.itemnum != 'undefined') {
                itemnum = field.itemnum;
              }
              if (typeof field.deselect != 'undefined') {
                deselect.push(field.deselect);
              }
              break;
          }

          if (itemnum) {
            if (typeof field.flat != 'undefined' && field.flat) {
              items[itemnum] = 1;
            } else if (typeof items[itemnum] == 'undefined') {
              items[itemnum] = (itemAmount ? itemAmount : amount);
            } else {
              items[itemnum] = items[itemnum] + (itemAmount ? itemAmount : amount);
            }
          }
        }
      }

      this.itemnums.forEach(function(itemnum) {
        if (itemnum == null || deselect.indexOf(itemnum) > -1) {
          return;
        }

        if (typeof items[itemnum] == 'undefined') {
          items[itemnum] = fileCount * amount;
        } else {
          items[itemnum] = items[itemnum] + (fileCount * amount);
        }
      }.bind(this));

      return items;
    }
  }
}
